import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system, { getColor } from '../../system';
import Base from '../Base';
import Screenreader from '../Screenreader';
import Icon from '../Icon';
import styles from './index.module.css';
import overwriteStyles from '@mediahuis/chameleon-theme-wl/lib/web/overwrites/icon-button.module.css';
const SYSTEM_PROPS = ['flexProps', 'marginProps', 'floatProps', 'positioningProps'];
const IconButton = /*#__PURE__*/function () {
  const IconButton = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      accessibilityLabel,
      appearance,
      as,
      circular,
      color,
      disabled,
      icon,
      onClick,
      size,
      ...props
    } = _ref;
    const [, colorSystemStyle] = getColor(color);
    // Only use color with appearance `default`
    const colorStyle = appearance === 'default' ? colorSystemStyle : undefined;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const combinedStyles = {
      ...styles,
      ...overwriteStyles
    };
    const classnames = {
      [combinedStyles.root]: true,
      // size
      [combinedStyles.small]: size === 'small',
      [combinedStyles.large]: size === 'large',
      // appearance
      [combinedStyles.default]: appearance === 'default',
      [combinedStyles.primary]: appearance === 'primary',
      [combinedStyles.secondary]: appearance === 'secondary',
      [combinedStyles.plain]: appearance === 'plain',
      [combinedStyles.outline]: appearance === 'outline',
      // disabled
      [combinedStyles.disabled]: disabled,
      // rounded
      [combinedStyles.square]: !circular,
      [combinedStyles.circular]: circular
    };
    return /*#__PURE__*/React.createElement(Base, _extends({
      as: as,
      className: cx(classnames, className),
      style: {
        color: colorStyle,
        ...style
      },
      disabled: disabled,
      ref: ref,
      onClick: onClick
    }, rest), /*#__PURE__*/React.createElement(Icon, {
      "aria-hidden": "true",
      as: icon,
      size: "small"
    }), accessibilityLabel ? /*#__PURE__*/React.createElement(Screenreader, null, accessibilityLabel) : null);
  });
  IconButton.displayName = 'IconButton';
  IconButton.identifier = IconButton.displayName; // used in docs website
  IconButton.clonableProps = SYSTEM_PROPS;
  IconButton.defaultProps = {
    appearance: 'default',
    as: 'button',
    size: 'large',
    flexShrink: 0
  };
  return IconButton;
}();
export default IconButton;